import { DateRangeType } from '../../../types/phlebotomist-dashboard';

export interface IRecruiterViewOptions {
  recruitmentGoals: boolean;
  recruiterStats: boolean;
  quarterlyGoal: boolean;
  donorPipelineStrip: boolean;
  newRegistrationsChart: boolean;
  donorChurnRate: boolean;
  showRatesDblUnit: boolean;
  retiredDonors: boolean;
  lapsedDonors: boolean;
}

export const DEFAULT_RECRUITER_VIEW_OPTIONS: IRecruiterViewOptions = {
  recruitmentGoals: true,
  recruiterStats: true,
  quarterlyGoal: true,
  donorPipelineStrip: true,
  newRegistrationsChart: true,
  donorChurnRate: true,
  showRatesDblUnit: true,
  retiredDonors: true,
  lapsedDonors: true,
};

export const RECRUITER_VIEW_OPTION_LABELS: {
  key: keyof IRecruiterViewOptions;
}[] = [
  { key: 'recruitmentGoals' },
  { key: 'recruiterStats' },
  { key: 'quarterlyGoal' },
  { key: 'donorPipelineStrip' },
  { key: 'newRegistrationsChart' },
  { key: 'donorChurnRate' },
  { key: 'showRatesDblUnit' },
  { key: 'retiredDonors' },
  { key: 'lapsedDonors' },
];

export const RECRUITER_SETTINGS_TAB = 'recruiter-dashboard';

export interface IDateRangeOptionGroup {
  options: { value: DateRangeType }[];
}

export const RECRUITER_DATE_RANGE_OPTIONS: IDateRangeOptionGroup[] = [
  {
    options: [
      { value: 'day' },
      { value: 'yesterday' },
      { value: 'week' },
      { value: 'lastWeek' },
      { value: 'month' },
      { value: 'lastMonth' },
      { value: 'quarter' },
      { value: 'lastQuarter' },
      { value: 'year' },
      { value: 'lastYear' },
    ],
  },
  {
    options: [
      { value: 'dayCal' },
      { value: 'yesterdayCal' },
      { value: 'weekCal' },
      { value: 'lastWeekCal' },
      { value: 'monthCal' },
      { value: 'lastMonthCal' },
      { value: 'quarterCal' },
      { value: 'lastQuarterCal' },
      { value: 'yearCal' },
      { value: 'pYearCal' },
    ],
  },
];
